import { Component, Input, Output, EventEmitter } from "@angular/core";
import { TooltipModule } from "primeng/tooltip";

@Component({
  selector: 'neo-matris-input',
  templateUrl: './matris-input.component.html',
  styleUrls: ['./matris-input.component.scss']
})

export class MatrisInputComponent {

  @Input() value: any;
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() valueInputChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBlurMethod: EventEmitter<any> = new EventEmitter<any>();
  @Input() id: any;
  @Input() name: any;
  @Input() helpText: string = ''
  @Input() placeholder: string = ''
  @Input() label: string = ''
  @Input() isInputDisabled: boolean;
  @Input() isRequired: boolean = false;
  @Input() inputWidth: string = '100%';
  @Input() floatRight: boolean = false;
  @Input() height: string = '67%'
  @Input() invalidInput: boolean;
  @Input() dialogInput: boolean;
  @Input() maxlength: string = ''
  @Input() type: string = ''
  @Input() isDisabledInputInvalid: boolean = false;
  @Output() enterPressed = new EventEmitter<void>();
  @Input() iconVisible : boolean = false;
  @Input() iconClass : string = ''
  @Input() pTooltip : string = ''
  @Input() tooltipMessage : string = ''
  @Input() toolTipOrientation : string = 'right'
  onValueChange(event: any) {
    this.valueChange.emit({ id: this.id, event: event });
  }

  onValueInputChange(event: any) {
    this.valueInputChange.emit({ id: this.id, event: event });
  }

  onInputChange(event: any) {
    const newValue = event.target.value;
    this.value = newValue;
  }
  onBlur(event: any) {
    this.onBlurMethod.emit({ id: this.id, event: event });
  }

  handleEnter(event: any) {
    this.enterPressed.emit(event);
  }


}
